import { Component, OnInit, Inject } from '@angular/core';
import { ProfileService } from 'app/profile/services/profile.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToolParameter, ToolParameterType, AssociatedPart, Part } from 'app/profile/models/generic.model';
import { Observable } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { debounceTime, startWith, map } from 'rxjs/operators';
import { TslDialogRef, TslMultiSelectSettings, TslOption, TSL_DIALOG_DATA } from '@tesla/ng-tds';

@Component({
	selector: 'app-associated-parts-form-dialog',
	templateUrl: './associated-parts-form-dialog.component.html',
	styleUrls: ['./associated-parts-form-dialog.component.scss']
})
export class AssociatedPartsFormDialogComponent implements OnInit {
	obParameterTypes$: Observable<ToolParameterType[]>;
	paramGroup: FormGroup;
	partsFiltered$: Observable<Part[]>;
	formattedParts: Part[];
	get partNumber() { return this.paramGroup.get('partNumber'); }
	selectedParts: Part[];
	searchSettings: TslMultiSelectSettings = {
		enableSearchFilter: true,
		labelKey: 'partTitle',
		primaryKey: 'description',
		enableCheckAll: false,
		searchMinLength: 3,
		contentWidth: 'content',
	}

	constructor(
		private fb: FormBuilder,
		private service: ProfileService,
		public dialogRef: TslDialogRef<AssociatedPartsFormDialogComponent>,
		@Inject(TSL_DIALOG_DATA) public data:
			{
				supplierCode: string,
				associatedParts: (AssociatedPart | any)[]
			}) {
		this.paramGroup = this.fb.group({
			partNumber: ['', Validators.required]
		});
	}

	ngOnInit() {
		this.loadResources();
	}

	onClose(): void {
		this.dialogRef.close();
	}

	onSave(): void {
		if (this.paramGroup.invalid) {
			return;
		}
		if (this.selectedParts && this.selectedParts.length > 0) {
			this.dialogRef.close(this.selectedParts);
		}
	}

	private loadResources(): void {

	}

	onSearch(prefixText: string): void {
		const filterValue = prefixText.toLowerCase();
		this.service.getPartsBySupplierCode(prefixText, this.data.supplierCode).subscribe(x => {
			x.forEach(y => {y.partTitle = y.partNumber + ' - ' + y.description });
			this.formattedParts = x;
		});
	}

	partAutoDisplay(part: Part): string {
		return part !== undefined ? `${part.partNumber} - ${part.description}` : '';
	}

	onSelectPart(option: TslOption): void {
		this.selectedParts = option.value.map(x => x as Part);
		console.log(this.selectedParts);
	}
}
